import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import {z} from 'zod';
import type {SignUpWithEmailData} from '../ports/auth.repository';

const signUpWithEmailDataSchema = z.object({
  email: z.email('Enter a valid email address.').trim().min(1, 'Email is required.'),
  password: z.string().min(8, 'Password must be at least 8 characters.'),
  name: z.string().trim().min(1, 'Name is required.'),
});

export class SignUpWithEmailDataValidator implements Validator<SignUpWithEmailData> {
  readonly standardSchema = signUpWithEmailDataSchema;

  validate(value: unknown): Result<SignUpWithEmailData, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);

    if (!parsed.success) {
      return err(
        new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid sign-up payload.'),
      );
    }

    return ok(parsed.data);
  }
}
